export default __webpack_public_path__ + "static/media/foreground1.d69d7c2c.png";